module.exports = __webpack_public_path__ + "static/prestige-logo-977181dc5f52e375c6722a86a988c606.svg";